import {Component, EventEmitter, Input, Output} from '@angular/core';

import {SelectCustomEvent} from '@ionic/angular';
@Component({
    selector: 'app-select-risorsa-scartomode',
    templateUrl: './select-risorsa-scartomode.component.html',
    styleUrls: ['./select-risorsa-scartomode.component.scss'],
    standalone: false
})
export class SelectRisorsaScartomodeComponent  {
  @Input() scartoMode = 0;
  @Output() scartoModeChange = new EventEmitter<number>();
  scartoModes = [
    {value: 0, label: 'Standard', description: 'Scarto gestito'},
    {value: 1, label: 'Detrai', description: 'Scarto viene detratto da avanzata'},
    {value: 2, label: 'Escludi', description: 'Non viene considerato'}
  ];
  selectScartoMode = (e: SelectCustomEvent) => this.scartoModeChange.emit(+e.target.value);
}
